import { TextInput, required } from "react-admin";
import { InputAdornment } from "@mui/material";

const validateYouTubeId = (value: any) => {
    if (!value) return undefined;
    const isValid = /^[\w-]{11}$/.test(value);
    return isValid ? undefined : "Invalid YouTube embed code (expected 11-char video ID)";
};

interface YouTubeInputProps {
    source: string;
    label?: string;
    [key: string]: any;
}

const YouTubeInput = ({ source, label = "YouTube Embed Code", ...rest }: YouTubeInputProps) => {
    const extractId = (value: string): string => {
        if (!value) return "";
        const match = value.match(/(?:embed\/|v=|youtu\.be\/)([\w-]{11})/);
        if (match) {
            return match[1];
        }
        return value; 
    };

    return (
        <TextInput
            {...rest}
            source={source}
            label={label}
            fullWidth
            id="youtube-input"
            parse={extractId}
            format={extractId} 
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        https://www.youtube.com/embed/
                    </InputAdornment>
                ),
            }}
            validate={[required(), validateYouTubeId]}
        />
    );
};

export default YouTubeInput;
